module.exports = __webpack_public_path__ + "img/logo.8174bed9.png";